import { render, staticRenderFns } from "./SimilarImageReviewCard.vue?vue&type=template&id=1c8855ff&scoped=true"
import script from "./SimilarImageReviewCard.vue?vue&type=script&lang=js"
export * from "./SimilarImageReviewCard.vue?vue&type=script&lang=js"
import style0 from "./SimilarImageReviewCard.vue?vue&type=style&index=0&id=1c8855ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8855ff",
  null
  
)

export default component.exports